import {Locale} from '@aboutyou/config';

export type DateFormatShort = 'dd.mm.' | 'mm.dd.' | 'mm-dd' | 'dd-mm' | 'dd/mm';

export function getShortDateFormatForLocale_UNSAFE(locale: Locale) {
  return countryDayMonthSpecifics[locale];
}

const countryDayMonthSpecifics: {
  [locale in Locale]: DateFormatShort;
} = {
  [Locale.en_ZZ]: 'mm-dd',
  [Locale.es_ZZ]: 'mm-dd',
  [Locale.de_DE]: 'dd.mm.',
  [Locale.en_DE]: 'dd.mm.',
  [Locale.de_AT]: 'dd.mm.',
  [Locale.en_AT]: 'dd.mm.',
  [Locale.de_CH]: 'dd.mm.',
  [Locale.fr_CH]: 'dd.mm.',
  [Locale.it_CH]: 'dd.mm.',
  [Locale.en_CH]: 'dd.mm.',
  [Locale.nl_NL]: 'dd-mm',
  [Locale.en_NL]: 'dd-mm',
  [Locale.pl_PL]: 'dd.mm.',
  [Locale.nl_BE]: 'dd/mm',
  [Locale.fr_BE]: 'dd/mm',
  [Locale.cs_CZ]: 'dd.mm.',
  [Locale.sk_SK]: 'dd.mm.',
  [Locale.hu_HU]: 'mm.dd.',
  [Locale.ro_RO]: 'dd.mm.',
  [Locale.sl_SI]: 'dd.mm.',
  [Locale.lv_LV]: 'dd.mm.',
  [Locale.ru_LV]: 'dd.mm.',
  [Locale.lt_LT]: 'mm-dd',
  [Locale.et_EE]: 'dd.mm.',
  [Locale.ru_EE]: 'dd.mm.',
  [Locale.hr_HR]: 'dd.mm.',
  [Locale.bg_BG]: 'dd.mm.',
  [Locale.fr_FR]: 'dd/mm',
  [Locale.da_DK]: 'dd.mm.',
  [Locale.sv_SE]: 'mm-dd',
  [Locale.fi_FI]: 'dd.mm.',
  [Locale.es_ES]: 'dd/mm',
  [Locale.it_IT]: 'dd/mm',
  [Locale.pt_PT]: 'dd/mm',
  [Locale.el_GR]: 'dd/mm',
  [Locale.el_CY]: 'dd/mm',
  [Locale.fr_LU]: 'dd/mm',
};
